import { clearTag, downloadTag, getAllTags } from "api/tags";
import { downloadExp } from "api/expression";
import { getAllDataSources, getAllTagTypeSources, getAllValueSources } from "api/dataSourceMeta";
import { getEquipmentTypes } from "api/equipments";

const actionApiConfig = {
  downloadTag,
  downloadExp,
  clearTag,
  getAllDataSources,
  getAllValueSources,
  getAllTagTypeSources,
  getAllTags,
  getEquipmentTypes
};

export default actionApiConfig;